import * as React from 'react';

import Icon from './Icon';

interface Props {
  size?: number;
  color?: string;
  children?: React.ReactNode;
}

const CloseIcon: React.FunctionComponent<Props> = props => {
  const size = props.size || 15;
  const color = props.color || 'white';
  return <Icon name={'close'} size={size} color={color} />;
};

export default React.memo(CloseIcon);
